/* eslint-disable no-unused-vars */
import actionFn from '../actionFn';
import * as type from '../mutationType';

const state = {
    productNo: '',
    token: '',
    themeImage: true
};

const getters = {};

/* eslint no-shadow: 0 */
const mutations = {
    [type.SET_PRODUCT_NO](state, payload) {
        if (payload) {
            state.productNo = payload;
        }
    },
    [type.SET_HAS_THEME](state, payload) {
        state.hasTheme = payload;
    }
};

const actions = {
    /**
     * 测试
     */
    login({ state, commit }, params) {
        const api = '/api/login';
        return actionFn(api, params, { server: 'dmsSysManager' });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/store/modules/common.js